"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportTypesTitleKeys = exports.reportTypesMap = exports.reportTypesChildren = exports.reportTypesCategoriesMap = exports.reportTypesCategories = exports.reportTypeOthers = exports.reportParentsCodes = exports._reportTypeOthers = exports.ReportType = void 0;
var _lockersWhite = _interopRequireDefault(require("../assets/images/parking/lockers-white.svg"));
var _shedWhite = _interopRequireDefault(require("../assets/images/parking/shed-white.svg"));
var _standsWhite = _interopRequireDefault(require("../assets/images/parking/stands-white.svg"));
var _wallLoopWhite = _interopRequireDefault(require("../assets/images/parking/wall-loop-white.svg"));
var _bicycleRepairWhite = _interopRequireDefault(require("../assets/images/poi/bicycle-repair-white.svg"));
var _chargingStationWhite = _interopRequireDefault(require("../assets/images/poi/charging-station-white.svg"));
var _picnicWhite = _interopRequireDefault(require("../assets/images/poi/picnic-white.svg"));
var _pumpWhite = _interopRequireDefault(require("../assets/images/poi/pump-white.svg"));
var _toiletsWhite = _interopRequireDefault(require("../assets/images/poi/toilets-white.svg"));
var _waterPointWhite = _interopRequireDefault(require("../assets/images/poi/water-point-white.svg"));
var _accidentWhite = _interopRequireDefault(require("../assets/images/report/accident-white.svg"));
var _advertisingWhite = _interopRequireDefault(require("../assets/images/report/advertising-white.svg"));
var _badWeatherWhite = _interopRequireDefault(require("../assets/images/report/bad-weather-white.svg"));
var _barrierWhite = _interopRequireDefault(require("../assets/images/report/barrier-white.svg"));
var _bicycleDammageWhite = _interopRequireDefault(require("../assets/images/report/bicycle-dammage-white.svg"));
var _bicycleFacilityRequestWhite = _interopRequireDefault(require("../assets/images/report/bicycle-facility-request-white.svg"));
var _bicycleParkingRequestWhite = _interopRequireDefault(require("../assets/images/report/bicycle-parking-request-white.svg"));
var _blindSpotWhite = _interopRequireDefault(require("../assets/images/report/blind-spot-white.svg"));
var _brokenGlassWhite = _interopRequireDefault(require("../assets/images/report/broken-glass-white.svg"));
var _dangerousCrossingWhite = _interopRequireDefault(require("../assets/images/report/dangerous-crossing-white.svg"));
var _dangerousExitWhite = _interopRequireDefault(require("../assets/images/report/dangerous-exit-white.svg"));
var _dangerousRoadWhite = _interopRequireDefault(require("../assets/images/report/dangerous-road-white.svg"));
var _deadLeavesWhite = _interopRequireDefault(require("../assets/images/report/dead-leaves-white.svg"));
var _dustbinWhite = _interopRequireDefault(require("../assets/images/report/dustbin-white.svg"));
var _faultyFacilitiesWhite = _interopRequireDefault(require("../assets/images/report/faulty-facilities-white.svg"));
var _floodWhite = _interopRequireDefault(require("../assets/images/report/flood-white.svg"));
var _freezingRainWhite = _interopRequireDefault(require("../assets/images/report/freezing-rain-white.svg"));
var _gcumWhite = _interopRequireDefault(require("../assets/images/report/gcum-white.svg"));
var _heavyCarTrafficWhite = _interopRequireDefault(require("../assets/images/report/heavy-car-traffic-white.svg"));
var _heavyPedestrianTrafficWhite = _interopRequireDefault(require("../assets/images/report/heavy-pedestrian-traffic-white.svg"));
var _incivilitiesWhite = _interopRequireDefault(require("../assets/images/report/incivilities-white.svg"));
var _kerbWhite = _interopRequireDefault(require("../assets/images/report/kerb-white.svg"));
var _mapErrorWhite = _interopRequireDefault(require("../assets/images/report/map-error-white.svg"));
var _markingErasedWhite = _interopRequireDefault(require("../assets/images/report/marking-erased-white.svg"));
var _missingFacilityWhite = _interopRequireDefault(require("../assets/images/report/missing-facility-white.svg"));
var _missingParkingWhite = _interopRequireDefault(require("../assets/images/report/missing-parking-white.svg"));
var _missingPoiWhite = _interopRequireDefault(require("../assets/images/report/missing-poi-white.svg"));
var _needMaintenanceWhite = _interopRequireDefault(require("../assets/images/report/need-maintenance-white.svg"));
var _noLightingWhite = _interopRequireDefault(require("../assets/images/report/no-lighting-white.svg"));
var _noMarkingWhite = _interopRequireDefault(require("../assets/images/report/no-marking-white.svg"));
var _obstaclesWhite = _interopRequireDefault(require("../assets/images/report/obstacles-white.svg"));
var _parkingNearCyclewayWhite = _interopRequireDefault(require("../assets/images/report/parking-near-cycleway-white.svg"));
var _pebblesWhite = _interopRequireDefault(require("../assets/images/report/pebbles-white.svg"));
var _poleWhite = _interopRequireDefault(require("../assets/images/report/pole-white.svg"));
var _policePresenceWhite = _interopRequireDefault(require("../assets/images/report/police-presence-white.svg"));
var _potholeWhite = _interopRequireDefault(require("../assets/images/report/pothole-white.svg"));
var _roadBlockedWhite = _interopRequireDefault(require("../assets/images/report/road-blocked-white.svg"));
var _roadworksWhite = _interopRequireDefault(require("../assets/images/report/roadworks-white.svg"));
var _rootsWhite = _interopRequireDefault(require("../assets/images/report/roots-white.svg"));
var _snowWhite = _interopRequireDefault(require("../assets/images/report/snow-white.svg"));
var _supportLocalAuthoritiesWhite = _interopRequireDefault(require("../assets/images/report/support-local-authorities-white.svg"));
var _trafficWhite = _interopRequireDefault(require("../assets/images/report/traffic-white.svg"));
var _treeWhite = _interopRequireDefault(require("../assets/images/report/tree-white.svg"));
var _vegetationWhite = _interopRequireDefault(require("../assets/images/report/vegetation-white.svg"));
var _icons = require("../components/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const reportParentsCodes = exports.reportParentsCodes = ['obstacles', 'incivilities', 'faultyFacilities', 'needMaintenance', 'dangerous', 'accident', 'roadBlocked', 'policePresence', 'traffic', 'badWeather', 'bikeFacility', 'bikeParkings', 'unlistedBicycleService', 'cartographicIssue', 'bicycleFacilityRequest', 'bicycleParkingRequest', 'supportLocalAuthorities', 'roadwork'];
const reportTypeObstaclesCodes = ['dustbin', 'gcum', 'pole', 'advertising', 'tree', 'vegetation', 'barrier'];
const reportTypeIncivilitiesCodes = ['theft', 'bicycleDammage'];
const reportTypeFaultyFacilitiesCodes = ['kerb', 'dangerousExit', 'dangerousCrossing', 'parkingNearCycleway', 'noMarking', 'noLighting', 'blindSpot'];
const reportTypeNeedMaintenanceCodes = ['pothole', 'markingErased', 'pebbles', 'brokenGlass', 'deadLeaves', 'roots'];
const reportTypeTrafficCodes = ['heavyBicycleTraffic', 'heavyCarTraffic', 'heavyPedestrianTraffic'];
const reportTypeBadWeatherCodes = ['snow', 'freezingRain', 'flood'];
const reportTypeBikeParkingsCodes = ['bikeParkingStands', 'bikeParkingWallLoop', 'bikeParkingShed', 'bikeParkingBollard', 'bikeParkingLockers', 'bikeParking'];
const reportTypeUnlistedBicycleServiceCodes = ['unlistedBicycleRepair', 'unlistedChargingStation', 'unlistedWaterPoint', 'unlistedToilets', 'unlistedPicnicArea', 'unlistedBicyclePump'];
const reportTypeOthers = exports.reportTypeOthers = ['exclusionZone', 'support', 'toDoToSee'];
const _reportTypeOthers = exports._reportTypeOthers = ['exclusionZone', 'support', 'toDoToSee'];
const reportTypesChildren = exports.reportTypesChildren = {
  obstacles: {
    children: reportTypeObstaclesCodes,
    isBindToOSM: false
  },
  incivilities: {
    children: reportTypeIncivilitiesCodes,
    isBindToOSM: false
  },
  faultyFacilities: {
    children: reportTypeFaultyFacilitiesCodes,
    isBindToOSM: false
  },
  needMaintenance: {
    children: reportTypeNeedMaintenanceCodes,
    isBindToOSM: false
  },
  dangerous: {
    children: [],
    isBindToOSM: false
  },
  accident: {
    children: [],
    isBindToOSM: false
  },
  roadBlocked: {
    children: [],
    isBindToOSM: false
  },
  policePresence: {
    children: [],
    isBindToOSM: false
  },
  traffic: {
    children: reportTypeTrafficCodes,
    isBindToOSM: false
  },
  badWeather: {
    children: reportTypeBadWeatherCodes,
    isBindToOSM: false
  },
  roadwork: {
    children: [],
    isBindToOSM: false
  },
  bikeFacility: {
    children: [],
    isBindToOSM: true
  },
  bikeParkings: {
    children: reportTypeBikeParkingsCodes,
    isBindToOSM: true
  },
  unlistedBicycleService: {
    children: reportTypeUnlistedBicycleServiceCodes,
    isBindToOSM: true
  },
  cartographicIssue: {
    children: [],
    isBindToOSM: true
  },
  bicycleFacilityRequest: {
    children: [],
    isBindToOSM: true
  },
  bicycleParkingRequest: {
    children: [],
    isBindToOSM: true
  },
  supportLocalAuthorities: {
    children: [],
    isBindToOSM: true
  }
};
const reportTypesCategories = exports.reportTypesCategories = ['danger', 'trafficConditions', 'mapError', 'suggestions'];
const reportTypesCategoriesMap = exports.reportTypesCategoriesMap = {
  danger: {
    Icon: _icons.DangerIcon,
    titleKey: 'commons.report_types.danger',
    children: ['obstacles', 'incivilities', 'faultyFacilities', 'needMaintenance', 'dangerous']
  },
  trafficConditions: {
    Icon: _icons.TrafficConditionsIcon,
    titleKey: 'commons.report_types.traffic_conditions',
    children: ['accident', 'roadBlocked', 'policePresence', 'traffic', 'badWeather']
  },
  mapError: {
    Icon: _icons.MapErrorIcon,
    titleKey: 'commons.report_types.map_error',
    children: ['bikeFacility', 'bikeParkings', 'unlistedBicycleService', 'cartographicIssue']
  },
  suggestions: {
    Icon: _icons.SuggestionsIcon,
    titleKey: 'commons.report_types.suggestions',
    children: ['bicycleFacilityRequest', 'bicycleParkingRequest', 'supportLocalAuthorities']
  }
};
class ReportType {
  constructor(id, code, isBindToOSM, titleKey, children) {
    this.id = id;
    this.code = code;
    this.isBindToOSM = isBindToOSM;
    this.titleKey = titleKey;
    this.children = children;
  }
}
exports.ReportType = ReportType;
const reportTypesTitleKeys = exports.reportTypesTitleKeys = {
  obstacles: 'commons.report_types.obstacles',
  dustbin: 'commons.report_types.dustbin',
  gcum: 'commons.report_types.gcum',
  pole: 'commons.report_types.pole',
  advertising: 'commons.report_types.advertising',
  tree: 'commons.report_types.tree',
  vegetation: 'commons.report_types.vegetation',
  barrier: 'commons.report_types.barrier',
  incivilities: 'commons.report_types.incivilities',
  theft: 'commons.report_types.theft',
  bicycleDammage: 'commons.report_types.bicycle_dammage',
  faultyFacilities: 'commons.report_types.faulty_facilities',
  kerb: 'commons.report_types.kerb',
  dangerousExit: 'commons.report_types.dangerous_exit',
  dangerousCrossing: 'commons.report_types.dangerous_crossing',
  parkingNearCycleway: 'commons.report_types.parking_near_cycleway',
  noMarking: 'commons.report_types.no_marking',
  noLighting: 'commons.report_types.no_lighting',
  blindSpot: 'commons.report_types.blind_spot',
  needMaintenance: 'commons.report_types.need_maintenance',
  pothole: 'commons.report_types.pothole',
  markingErased: 'commons.report_types.marking_erased',
  pebbles: 'commons.report_types.pebbles',
  brokenGlass: 'commons.report_types.broken_glass',
  deadLeaves: 'commons.report_types.dead_leaves',
  roots: 'commons.report_types.roots',
  dangerous: 'commons.report_types.dangerous',
  accident: 'commons.report_types.accident',
  roadBlocked: 'commons.report_types.road_blocked',
  policePresence: 'commons.report_types.police_presence',
  traffic: 'commons.report_types.traffic',
  heavyBicycleTraffic: 'commons.report_types.heavy_bicycle_traffic',
  heavyCarTraffic: 'commons.report_types.heavy_car_traffic',
  heavyPedestrianTraffic: 'commons.report_types.heavy_pedestrian_traffic',
  badWeather: 'commons.report_types.bad_weather',
  snow: 'commons.report_types.snow',
  freezingRain: 'commons.report_types.freezing_rain',
  flood: 'commons.report_types.flood',
  bikeFacility: 'commons.report_types.bike_facility',
  bikeParkings: 'commons.report_types.bike_parkings',
  bikeParkingStands: 'commons.report_types.bike_parking_stands',
  bikeParkingWallLoop: 'commons.report_types.bike_parking_wall_loop',
  bikeParkingShed: 'commons.report_types.bike_parking_shed',
  bikeParkingBollard: 'commons.report_types.bike_parking_bollard',
  bikeParkingLockers: 'commons.report_types.bike_parking_lockers',
  bikeParking: 'commons.report_types.bike_parking',
  unlistedBicycleService: 'commons.report_types.unlisted_bicycle_service',
  unlistedBicycleRepair: 'commons.report_types.unlisted_bicycle_repair',
  unlistedChargingStation: 'commons.report_types.unlisted_charging_station',
  unlistedWaterPoint: 'commons.report_types.unlisted_water_point',
  unlistedToilets: 'commons.report_types.unlisted_toilets',
  unlistedPicnicArea: 'commons.report_types.unlisted_picnic_area',
  unlistedBicyclePump: 'commons.report_types.unlisted_bicycle_pump',
  cartographicIssue: 'commons.report_types.cartographic_issue',
  bicycleFacilityRequest: 'commons.report_types.bicycle_facility_request',
  bicycleParkingRequest: 'commons.report_types.bicycle_parking_request',
  supportLocalAuthorities: 'commons.report_types.support_local_authorities',
  exclusionZone: 'commons.report_types.exclusion_zone',
  support: 'commons.report_types.support',
  roadwork: 'commons.report_types.roadwork',
  toDoToSee: 'commons.report_types.to_do_to_see'
  // roadwork: 'commons.report_types.roadwork',
};
const reportTypesMap = exports.reportTypesMap = {
  obstacles: {
    Icon: _icons.ObstaclesIcon,
    color: '#da3a87',
    icon: _obstaclesWhite.default
  },
  dustbin: {
    Icon: _icons.DustbinIcon,
    color: '#da3a87',
    icon: _dustbinWhite.default
  },
  gcum: {
    Icon: _icons.GCUMIcon,
    color: '#da3a87',
    icon: _gcumWhite.default
  },
  pole: {
    Icon: _icons.PoleIcon,
    color: '#da3a87',
    icon: _poleWhite.default
  },
  advertising: {
    Icon: _icons.AdvertisingIcon,
    color: '#da3a87',
    icon: _advertisingWhite.default
  },
  tree: {
    Icon: _icons.TreeIcon,
    color: '#da3a87',
    icon: _treeWhite.default
  },
  vegetation: {
    Icon: _icons.VegetationIcon,
    color: '#da3a87',
    icon: _vegetationWhite.default
  },
  barrier: {
    Icon: _icons.BarrierIcon,
    color: '#da3a87',
    icon: _barrierWhite.default
  },
  incivilities: {
    Icon: _icons.IncivilitiesIcon,
    color: '#da3a87',
    icon: _incivilitiesWhite.default
  },
  theft: {
    Icon: _icons.TheftIcon,
    color: '#da3a87',
    icon: _incivilitiesWhite.default
  },
  bicycleDammage: {
    Icon: _icons.BicycleDammageIcon,
    color: '#da3a87',
    icon: _bicycleDammageWhite.default
  },
  faultyFacilities: {
    Icon: _icons.FaultyFacilitiesIcon,
    color: '#da3a87',
    icon: _faultyFacilitiesWhite.default
  },
  kerb: {
    Icon: _icons.KerbIcon,
    color: '#da3a87',
    icon: _kerbWhite.default
  },
  dangerousExit: {
    Icon: _icons.DangerousExitIcon,
    color: '#da3a87',
    icon: _dangerousExitWhite.default
  },
  dangerousCrossing: {
    Icon: _icons.DangerousCrossingIcon,
    color: '#da3a87',
    icon: _dangerousCrossingWhite.default
  },
  parkingNearCycleway: {
    Icon: _icons.ParkingNearCyclewayIcon,
    color: '#da3a87',
    icon: _parkingNearCyclewayWhite.default
  },
  noMarking: {
    Icon: _icons.NoMarkingIcon,
    color: '#da3a87',
    icon: _noMarkingWhite.default
  },
  noLighting: {
    Icon: _icons.NoLightingIcon,
    color: '#da3a87',
    icon: _noLightingWhite.default
  },
  blindSpot: {
    Icon: _icons.BlindSpotIcon,
    color: '#da3a87',
    icon: _blindSpotWhite.default
  },
  needMaintenance: {
    Icon: _icons.NeedMaintenanceIcon,
    color: '#da3a87',
    icon: _needMaintenanceWhite.default
  },
  pothole: {
    Icon: _icons.PotholeIcon,
    color: '#da3a87',
    icon: _potholeWhite.default
  },
  markingErased: {
    Icon: _icons.MarkingErasedIcon,
    color: '#da3a87',
    icon: _markingErasedWhite.default
  },
  pebbles: {
    Icon: _icons.PebblesIcon,
    color: '#da3a87',
    icon: _pebblesWhite.default
  },
  brokenGlass: {
    Icon: _icons.BrokenGlassIcon,
    color: '#da3a87',
    icon: _brokenGlassWhite.default
  },
  deadLeaves: {
    Icon: _icons.DeadLeavesIcon,
    color: '#da3a87',
    icon: _deadLeavesWhite.default
  },
  roots: {
    Icon: _icons.RootsIcon,
    color: '#da3a87',
    icon: _rootsWhite.default
  },
  dangerous: {
    Icon: _icons.DangerousRoadIcon,
    color: '#dd428d',
    icon: _dangerousRoadWhite.default
  },
  accident: {
    Icon: _icons.AccidentIcon,
    color: '#fa823e',
    icon: _accidentWhite.default
  },
  roadBlocked: {
    Icon: _icons.BlockedRoadIcon,
    color: '#fa823e',
    icon: _roadBlockedWhite.default
  },
  policePresence: {
    Icon: _icons.PolicePresenceIcon,
    color: '#fa823e',
    icon: _policePresenceWhite.default
  },
  traffic: {
    Icon: _icons.TrafficIcon,
    color: '#fa823e',
    icon: _trafficWhite.default
  },
  heavyBicycleTraffic: {
    Icon: _icons.TrafficIcon,
    color: '#fa823e',
    icon: _trafficWhite.default
  },
  heavyCarTraffic: {
    Icon: _icons.HeavyCarTrafficIcon,
    color: '#fa823e',
    icon: _heavyCarTrafficWhite.default
  },
  heavyPedestrianTraffic: {
    Icon: _icons.HeavyPedestrianTrafficIcon,
    color: '#fa823e',
    icon: _heavyPedestrianTrafficWhite.default
  },
  badWeather: {
    Icon: _icons.BadWeatherIcon,
    color: '#fa823e',
    icon: _badWeatherWhite.default
  },
  snow: {
    Icon: _icons.SnowIcon,
    color: '#B9BDC3',
    icon: _snowWhite.default
  },
  freezingRain: {
    Icon: _icons.FreezingRainIcon,
    color: '#37B1E5',
    icon: _freezingRainWhite.default
  },
  flood: {
    Icon: _icons.FloodIcon,
    color: '#528BE8',
    icon: _floodWhite.default
  },
  bikeFacility: {
    Icon: _icons.MissingFacilityIcon,
    color: '#048760',
    icon: _missingFacilityWhite.default
  },
  bikeParkings: {
    Icon: _icons.MissingParkingIcon,
    color: '#048760',
    icon: _missingParkingWhite.default
  },
  bikeParkingStands: {
    Icon: _icons.StandsIcon,
    color: '#326AC2',
    icon: _standsWhite.default
  },
  bikeParkingWallLoop: {
    Icon: _icons.WallLoopIcon,
    color: '#326AC2',
    icon: _wallLoopWhite.default
  },
  bikeParkingShed: {
    Icon: _icons.ShedIcon,
    color: '#326AC2',
    icon: _shedWhite.default
  },
  bikeParkingBollard: {
    Icon: _icons.StandsIcon,
    color: '#326AC2',
    icon: _standsWhite.default
  },
  bikeParkingLockers: {
    Icon: _icons.LockersIcon,
    color: '#326AC2',
    icon: _lockersWhite.default
  },
  bikeParking: {
    Icon: _icons.WallLoopIcon,
    color: '#326AC2',
    icon: _wallLoopWhite.default
  },
  unlistedBicycleService: {
    Icon: _icons.MissingPoiIcon,
    color: '#048760',
    icon: _missingPoiWhite.default
  },
  unlistedBicycleRepair: {
    Icon: _icons.BicycleRepairIcon,
    color: '#5ABA52',
    icon: _bicycleRepairWhite.default
  },
  unlistedChargingStation: {
    Icon: _icons.ChargingStationIcon,
    color: '#EBAF25',
    icon: _chargingStationWhite.default
  },
  unlistedWaterPoint: {
    Icon: _icons.WaterPointIcon,
    color: '#37B1E5',
    icon: _waterPointWhite.default
  },
  unlistedToilets: {
    Icon: _icons.ToiletsIcon,
    color: '#969696',
    icon: _toiletsWhite.default
  },
  unlistedPicnicArea: {
    Icon: _icons.PicnicIcon,
    color: '#5ABA52',
    icon: _picnicWhite.default
  },
  unlistedBicyclePump: {
    Icon: _icons.PumpIcon,
    color: '#F260A7',
    icon: _pumpWhite.default
  },
  cartographicIssue: {
    Icon: _icons.CartographicIssueIcon,
    color: '#048760',
    icon: _mapErrorWhite.default
  },
  bicycleFacilityRequest: {
    Icon: _icons.BicycleFacilityRequestIcon,
    color: '#bb8a1a',
    icon: _bicycleFacilityRequestWhite.default
  },
  bicycleParkingRequest: {
    Icon: _icons.BicycleParkingRequestIcon,
    color: '#bb8a1a',
    icon: _bicycleParkingRequestWhite.default
  },
  supportLocalAuthorities: {
    Icon: _icons.SupportLocalAuthoritiesIcon,
    color: '#bb8a1a',
    icon: _supportLocalAuthoritiesWhite.default
  },
  roadwork: {
    Icon: _icons.RoadworksIcon,
    color: '#ee7734',
    icon: _roadworksWhite.default
  }
};